import HeavyLink from "./HeavyLink.js";

export default HeavyLink;